<!-- //-----------------------------------------------------------------------
// <copyright file="dashboard.component.html" company="LGT India">
//     Author: vanaraj  
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//----------------------------------------------------------------------- -->

<main role="main" class="container mt-5">
  <div class="container">
    <div class="text-center mt-5">
      <h3>Welcome to LGT INDIA</h3>
      <p
        class="text-bold"
        [innerText]="
          'Hi ' +
          this.user.displayName +
          ', your Firebase ID is ' +
          this.user.localId
        "
      ></p>
      <button
        mat-raised-button
        color="primary"
        style="
          width: 394px;
          height: 54px;
          padding: 18px, 0px, 18px, 0px;
          border-radius: 5.76px;
          background: #00498f;
        "
        (click)="goToHomePage()"
      >
        Go to Transaction
      </button>
    </div>
  </div>
</main>
